import { render, staticRenderFns } from "./AppCookies.vue?vue&type=template&id=747f4133&"
import script from "./AppCookies.vue?vue&type=script&lang=js&"
export * from "./AppCookies.vue?vue&type=script&lang=js&"
import style0 from "./AppCookies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports